/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import StepNav from 'material/embeds/steps/stepnav/stepnav';



/* ========== ~~~~~~~~~~ STEP NAV : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { handleSaveEmbed }) => ({
    stepQueue: embedsState.embedManagementState.embedManagementStatus.stepQueue,
    stepQueueContent: embedsState.embedManagementState.embedManagementStatus.stepQueueContent,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    handleSaveEmbed
});

// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    // mapDispatchToProps
)(StepNav);
